import { onUnmounted } from 'vue'

export function usePolling(callback, { intervalMs = 10000 } = {}) {
  let timerId = null
  let active = false
  let running = false

  function isHidden() {
    return typeof document !== 'undefined' && document.hidden
  }

  function clearTimer() {
    if (timerId === null) return

    clearInterval(timerId)
    timerId = null
  }

  async function runCallback() {
    if (running) return

    running = true
    try {
      await callback()
    } catch (error) {
      console.error('Polling callback failed', error)
    } finally {
      running = false
    }
  }

  function schedule() {
    if (!active || isHidden() || typeof window === 'undefined') return
    if (timerId !== null) return

    timerId = window.setInterval(() => {
      if (!isHidden()) runCallback()
    }, intervalMs)
  }

  function start() {
    active = true
    schedule()
  }

  function stop() {
    active = false
    clearTimer()
  }

  function refreshNow() {
    return runCallback()
  }

  function handleVisibilityChange() {
    if (isHidden()) {
      clearTimer()
    } else {
      schedule()
    }
  }

  function handleFocus() {
    if (active && !isHidden()) {
      runCallback()
    }
  }

  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', handleVisibilityChange)
  }

  if (typeof window !== 'undefined') {
    window.addEventListener('focus', handleFocus)
  }

  onUnmounted(() => {
    stop()

    if (typeof document !== 'undefined') {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }

    if (typeof window !== 'undefined') {
      window.removeEventListener('focus', handleFocus)
    }
  })

  return {
    start,
    stop,
    refreshNow,
  }
}
